declare global {
  interface Window {
    gtag?: (
      command: "event",
      eventName: string,
      params?: Record<string, unknown>
    ) => void
  }
}

export type Page = "app_ordi" | "app_mobile" | "app_payment"

export type Section = "connexion" | "onboarding" | "home" | "pricing"

export type EventCategory = "conversion" | "usage" | "engagement"

export type CtaName =
  | "inscrivez_vous"
  | "se_connecter"
  | "etp1_confirmer"
  | "etp2_confirmer"
  | "etp3_confirmer"
  | "finaliser"
  | "choisir_formule"
  | "formule_mensuelle"
  | "formule_annuelle"
  | "demander_demo"
  | "rappelordi_mail"

type CtaEventParams = {
  page: Page
  section?: Section
  event_category: EventCategory
  cta_text: CtaName
}

function trackEvent(eventName: string, params: Record<string, unknown>) {
  if (typeof window === "undefined" || !window.gtag) return
  window.gtag("event", eventName, params)
}

function trackCTA(params: CtaEventParams) {
  trackEvent("cta_click", params)
}

export const Analytics = {
  cta: {
    click: trackCTA,
  },
}
